import http from 'hub-http/clients/apiClient';
import { AUDIENCES_OBJECT_TYPE, AUDIENCE_CRM_PROPERTIES } from '../constants';
import { CRM_SEARCH_URL } from '../constants/urls';
const defaultQuery = {
  query: '',
  objectTypeId: AUDIENCES_OBJECT_TYPE,
  offset: 0,
  count: 25,
  filterGroups: [{
    filters: [{
      operator: 'EQ',
      property: AUDIENCE_CRM_PROPERTIES.IS_REUSABLE,
      value: 'true'
    }]
  }],
  requestOptions: {
    allPropertiesFetchMode: 'latest_version',
    includeAllProperties: true
  },
  sorts: [{
    property: AUDIENCE_CRM_PROPERTIES.LAST_MODIFIED,
    order: 'DESC'
  }]
};
export const getAudiencesFromCrm = (query = {}) => http.post(CRM_SEARCH_URL, {
  data: Object.assign({}, defaultQuery, query)
});